import React from "react";

interface TextInputControlsProps {
  newText: string;
  onTextChange: (text: string) => void;
  onAddText: () => void;
}

const TextInputControls: React.FC<TextInputControlsProps> = ({
  newText,
  onTextChange,
  onAddText,
}) => {
  return (
    <div className="mb-6 p-4 bg-gray-50 rounded-lg">
      <div className="flex flex-col sm:flex-row-reverse gap-4">
        <input
          type="text"
          value={newText}
          onChange={(e) => onTextChange(e.target.value)}
          placeholder="הכנס טקסט כאן..."
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent text-center"
          dir="rtl"
        />
        <button
          onClick={onAddText}
          className="px-4 sm:px-6 lg:px-8 py-2 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 font-medium whitespace-nowrap text-sm sm:text-base"
        >
          הוסף
        </button>
      </div>
    </div>
  );
};

export default TextInputControls;
